import { render } from "./IconSupportSuccess.vue?vue&type=template&id=4c3f3936"
const script = {}

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__